<template lang="pug">
  div
    h2(class="new-advert-subtitle mb-4") Выберете тип объявления:
    v-row(no-gutters)
      v-btn-toggle(mandatory v-model="duration" class="toggle-buttons")
        v-row(no-gutters justify="start")
          v-btn(
            v-for="item in durations"
            :key="item.id"
            :value="item.value")
            v-col
              img(
                :src="require(`@/assets/images/icons/duration/${item.value === duration ? item.activeIcon : item.icon}.svg`)",
                :alt="`${item.icon} icon`")
              div(class="v-btn-title") {{ item.title }}
</template>

<script>
export default {
  name: 'Durations',
  data: () => ({
    durations: [
      {
        id: '1',
        title: 'Сдать посуточно',
        value: 'daily',
        icon: 'clock',
        activeIcon: 'clock_active'
      },
      {
        id: '2',
        title: 'Сдать длительно',
        value: 'longer',
        icon: 'appointment',
        activeIcon: 'appointment_active'
      },
      {
        id: '3',
        title: 'Продать',
        value: 'sell',
        icon: 'money',
        activeIcon: 'money_active'
      }
    ],
    duration: 'daily'
  }),
  watch: {
    duration: {
      immediate: true,
      handler(value) {
        this.$emit('set-toggle-duration', value)
      }
    }
  }
}
</script>
